import React from 'react';
import './main.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Logger } from '@elyx-code/common-ts-utils';

// In your global setup file (e.g., index.js)
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function<T extends Node>(child: T): T {
  try {
    return originalRemoveChild.call(this, child) as T;
  } catch (error) {
    if (error instanceof Error && error.message.includes("not a child")) {
      Logger.warn("Swallowed removeChild error:", error);
      return child;
    }
    throw error;
  }
};

createRoot(document.getElementById('injection-target') as HTMLElement).render(
	<App />
);
